import React from 'react'
import { useNavigate } from 'react-router-dom'
import { imageUrl } from '../../utils'

const BackToCaseStudiesHeader = () => {
  const navigate = useNavigate()

  return (
    <div className="w-full border-b border-t border-[#E6E6E6] bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div 
          className="flex items-center gap-3 py-4 cursor-pointer hover:opacity-70 transition-opacity"
          onClick={() => navigate('/projects')}
        >
          <img 
            className="w-5 h-5" 
            src={imageUrl('arrow_left.svg')} 
            alt="Back arrow" 
          />
          <span className="text-base font-medium text-gray-700">
            Back to case studies
          </span>
        </div>
      </div>
    </div>
  )
}

export default BackToCaseStudiesHeader